import type { MapPin } from '@/components/maps/MapView';

export const mergeItineraryPinsForActiveItems = (
  prevPins: MapPin[],
  pinsToAdd: MapPin[],
  activeItineraryPinIds: Set<string>,
): MapPin[] => {
  const otherPins = prevPins.filter((p) => p.type !== 'itinerary');
  // Reconcile with current itinerary snapshot to prevent stale pins from persisting
  // after item deletion/day moves/location edits.
  const existingItineraryPins = prevPins.filter(
    (p) => p.type === 'itinerary' && activeItineraryPinIds.has(p.id),
  );

  // Merge by id to avoid duplicates if a group re-geocodes the same item.
  const mergedById = new Map<string, MapPin>();
  [...existingItineraryPins, ...pinsToAdd].forEach((pin) => {
    mergedById.set(pin.id, pin);
  });

  const mergedItineraryPins = Array.from(mergedById.values()).filter((p) => p.type === 'itinerary');
  return [...otherPins, ...mergedItineraryPins];
};
